<template>
  <v-dialog
  v-model="showDialog"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="list-users-actions-enableUser-activator">
        <slot></slot>
      </div>
    </template>


    <div class="vb-dialog " v-bind:class="confirmationClass">
      <v-card v-cloak data-cy="dialog--------">
        <v-card-title class="d-flex justify-space-between mb-2">
          {{ this.isMFAEnabled ? $t('menus.configuration.disableMFATitle') : $t('menus.configuration.enableMFATitle')}}

          <v-btn icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text data-cy="dialog------">
          <div class="mb-2">{{ this.isMFAEnabled ? $t('menus.setMFA.disableMFARequirement') : $t('menus.setMFA.enableMFARequirement')}}</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:class="confirmationClassButton" @click="submitForm" elevation=0>
            {{ this.isMFAEnabled ? $t('common.disable') : $t('common.enable') }}
          </v-btn>

          <v-btn variant="text" @click="closeDialog()" data-cy="dialog--------">
            {{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useSystemStore } from '@/stores/SystemStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ['update:modelValue'],
  mixins: [DialogActionKeys],
  name: "MFATenantDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      successMessage: "",
      errorMessage: "",
    }
  },
  watch: {
    showDialog() {
      this.refreshMFAEnabled();

      this.errorMessage = "";
      this.successMessage = "";
    }
  },
  methods: {
    async submitForm() {
      this.errorMessage = "";
      this.successMessage = "";

      const authStore = useAuthStore();
      const accessPointId = authStore.rootNodeId;

      let payload = {
        mfarequired: !this.isMFAEnabled,
        accessPointId,
      }

      try {
        const systemStore = useSystemStore();
        await systemStore.updateTenantMFA(payload);

        this.$showMessage(payload.mfarequired ? this.$t('menus.setMFA.enabledSuccessfully') : this.$t('menus.setMFA.disabledSuccessfully'));
        this.closeDialog();
      } catch (error) {
        if (error && error.message) {
          this.$showMessage(error.message, {type: 'error'});
        }

        console.error(error);
        this.closeDialog();
      }
    },
    refreshMFAEnabled: function() {
      const authStore = useAuthStore();
      authStore.refreshDBUser();
    },
    closeDialog() {
      this.showDialog = false;
    }
  },
  computed: {
    isMFAEnabled: function() {
      const authStore = useAuthStore();
      const tenant = authStore.getActiveTenant;

      return tenant  ? tenant.mfarequired : false;
    },
    confirmationClassButton: function() {
      return this.isMFAEnabled ? 'bg-red-darken-3' : 'bg-primary';
    },
    confirmationClass: function() {
      return this.isMFAEnabled ? 'vb-dialog-danger' : 'primary';
    },
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
}
</script>

<style>
</style>
